import { history } from '@umijs/max';
import { ParsedQuery } from 'query-string';
import { PatchQuery, SetQuery, UseQuery } from './types';

export const useQuery: UseQuery = <TValue extends ParsedQuery>(
  initialValue?: TValue,
  stripValues = [undefined, null, '', 0, '0'],
) => {
  const { location } = history;
  const { query: oldQuery } = location;

  const query: TValue = {
    ...initialValue,
    ...(oldQuery as any),
  };

  const updateQuery = (state: Partial<TValue>) => {
    const newQueryString = pickBy(
      state,
      (value) => !stripValues.includes(value),
    );

    history.push({ query: newQueryString });
  };

  const setQuery: SetQuery<TValue> = (state) => updateQuery(state);
  const patchQuery: PatchQuery<TValue> = (state) =>
    updateQuery({ ...query, ...state });

  return [query, setQuery, patchQuery];
};

const pickBy = (
  object: Record<any, any>,
  predicate: (value: any) => boolean,
): Record<any, any> => {
  return Object.keys(object).reduce((accumulator: any, key) => {
    const value = object[key];

    if (predicate(value)) {
      accumulator[key] = value;
    }

    return accumulator;
  }, {});
};
